
























































import Vue from 'vue';
import Component from 'vue-class-component';
import TicketForm from '@/components/tickets/tickets-form/TicketForm.vue';
import { Typing } from '@/modules/tickets/shared/domain/typing';
import IncidentsDrawer from '@/modules/tickets/incidents/shared/components/IncidentDrawer.vue';
import { layout } from '@/modules/shared/shared/store/namespaces';
import { LayoutMutations } from '@/modules/shared/layouts/store/layout.mutations';
import { LayoutTitle } from '@/modules/shared/layouts/domain/layout-title';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';
import { networkSecurityInternetIncident } from '@/modules/tickets/shared/store/namespaces';
import NetworkSecurityInternetGeneralInformation from '@/modules/tickets/incidents/network-security-internet/components/NetworkSecurityInternetGeneralInformation.vue';
import NetworkSecurityInternetTicketConfirmation from '@/modules/tickets/incidents/network-security-internet/components/NetworkSecurityInternetTicketConfirmation.vue';
import { NetworkSecurityInternetIncidentData } from '@/modules/tickets/incidents/network-security-internet/domain/network-security-internet-incident-data';
import { NetworkSecurityInternetIncidentGetters } from '@/modules/tickets/incidents/network-security-internet/store/network-security-internet-incident.getters';
import { NetworkSecurityInternetIncidentActions } from '@/modules/tickets/incidents/network-security-internet/store/network-security-internet-incident.actions';
import { Incident } from '@/modules/tickets/incidents/shared/domain/incident';

@Component({
    name: 'network-security-internet-incident',
    components: {
        NetworkSecurityInternetGeneralInformation,
        NetworkSecurityInternetTicketConfirmation,
        IncidentsDrawer,
        TicketForm,
    },
})
export default class NetworkSecurityInternetIncident extends Vue {
    private currentStep: number = 1;
    private isValid: boolean = true;
    private highestStepReached: number = 1;
    private isMounted = false;

    async sendIncidentTicket() {
        EventBus.$emit(EventBusMessages.SHOW_LOADER);
        const failed = await this.createTicket(this.formValues.generalInformation);
        if (failed) {
            failed.showError();
        } else {
            this.$router.push({
                name: 'tickets',
            });
        }
        EventBus.$emit(EventBusMessages.HIDE_LOADER);
    }

    nextStep() {
        if (this.currentStep < 2) {
            this.currentStep++;
            this.highestStepReached = this.currentStep;
        }
    }

    previousStep() {
        if (this.currentStep > 1) {
            this.currentStep--;
        }
    }

    async mounted() {
        EventBus.$emit(EventBusMessages.SHOW_LOADER);
        this.changeTitle({
            route: ['Tickets'],
            title: 'Incidente de Redes, Seguridad e Internet',
        });
        const failed = await this.fetchView();

        if (failed) {
            failed.showError();
        }

        this.isMounted = true;
        EventBus.$emit(EventBusMessages.HIDE_LOADER);
    }

    @layout.Mutation(LayoutMutations.CHANGE_TITLE)
    changeTitle!: (layout: LayoutTitle) => void;

    @networkSecurityInternetIncident.Action(NetworkSecurityInternetIncidentActions.FETCH_VIEW)
    fetchView!: () => Promise<RequestResponse>;

    @networkSecurityInternetIncident.Getter(NetworkSecurityInternetIncidentGetters.GET_FORM_VALUES)
    formValues!: {
        generalInformation: NetworkSecurityInternetIncidentData;
        typings: Typing[];
    };

    @networkSecurityInternetIncident.Action(NetworkSecurityInternetIncidentActions.CREATE_TICKET)
    createTicket!: (data: NetworkSecurityInternetIncidentData) => Promise<RequestResponse>;

    @networkSecurityInternetIncident.Getter(
        NetworkSecurityInternetIncidentGetters.GET_OPEN_INCIDENTS,
    )
    incidents!: Incident[];
}
